import { Schedule } from "@aura-frontend/omnibus-az-client";
import { formatDate } from "@win-reality/react-ui";

import { isPractice } from "@/components/EventForm/EventForm.schema";
import { getEventTimes } from "@/utils/eventUtils";
import { labelForLedMode } from "@/utils/machineLedMode";
import { getScheduleEventName } from "@/utils/scheduleName";

import BatIcon from "../../../assets/bat.svg";
import FieldIcon from "../../../assets/field.svg";

type FieldEventProps = {
  event: Schedule;
};

function UpcomingFieldCardEvent({ event }: FieldEventProps) {
  const game = event.merged?.game;

  if (!game) {
    return <div>no game error</div>;
  }

  const gameType = game.type!;

  const eventName = getScheduleEventName(event);
  const { startTime, endTime } = getEventTimes(game);

  const getWeekdayAndDate = (dateString: string | number) => {
    const date = new Date(dateString);
    const dayOfWeek = new Intl.DateTimeFormat("en-US", {
      weekday: "short",
    }).format(date);
    const monthDay = formatDate(date, "MMM d");
    return `${dayOfWeek}, ${monthDay}`;
  };

  if (!isPractice(gameType)) {
    return (
      <div className="flex gap-4 items-center">
        <img src={FieldIcon} alt="Practice Event" className="h-7 w-auto" />

        <div className="flex flex-col gap-[0.02rem]">
          <div className="text-sm mb-0.5">{eventName}</div>
          <div className="text-xs text-gray-400">
            {formatDate(new Date(startTime), "M/d/yy, h:mm a")}
          </div>

          <div className="text-xs text-gray-400">
            {labelForLedMode(event.merged?.led ?? null)}
          </div>
        </div>
      </div>
    );
  }

  if (isPractice(gameType)) {
    return (
      <div className="flex gap-4 items-center">
        <img src={BatIcon} alt="Practice Event" className="h-7 w-auto" />

        <div className="flex flex-col gap-[0.02rem]">
          <div className="text-sm mb-0.5">{eventName}</div>
          <div className="text-xs text-gray-400">
            {getWeekdayAndDate(startTime)}{" "}
            {formatDate(new Date(startTime), "h:mm a")} {" - "}
            {endTime && formatDate(new Date(endTime), "h:mm a")}
          </div>

          <div className="text-xs text-gray-400">
            {labelForLedMode(event.merged?.led ?? null)}
          </div>
        </div>
      </div>
    );
  }

  return <div>Unknown event type</div>;
}

export { UpcomingFieldCardEvent };
